export const SPORTS = [
  { id: "all", label: "All" },
  { id: "baseball", label: "Baseball" },
  { id: "basketball", label: "Basketball" },
  { id: "hockey", label: "Hockey" },
  { id: "soccer", label: "Soccer" },
];

const baseballMarkets = [
  {
    id: "moneyline",
    label: "Moneyline",
    options: [
      { id: "sea-win", label: "Seattle Orcas to win", odds: 110, demoProbability: 0.42, market: "moneyline", team: "SEA", player: null, direction: null, line: null },
      { id: "por-win", label: "Portland Pioneers to win", odds: -135, demoProbability: 0.58, market: "moneyline", team: "POR", player: null, direction: null, line: null },
    ],
  },
  {
    id: "total-runs",
    label: "Total runs",
    options: [
      { id: "over-7-5", label: "Total over 7.5", odds: -110, demoProbability: 0.64, market: "total", team: null, player: null, direction: "over", line: 7.5 },
      { id: "under-7-5", label: "Total under 7.5", odds: -110, demoProbability: 0.36, market: "total", team: null, player: null, direction: "under", line: 7.5 },
    ],
  },
  {
    id: "run-line",
    label: "Run line",
    options: [
      { id: "sea-plus-1-5", label: "Seattle Orcas +1.5", odds: -160, demoProbability: 0.67, market: "run_line", team: "SEA", player: null, direction: null, line: 1.5 },
      { id: "por-minus-1-5", label: "Portland Pioneers -1.5", odds: 140, demoProbability: 0.33, market: "run_line", team: "POR", player: null, direction: null, line: -1.5 },
    ],
  },
  {
    id: "pitching",
    label: "Pitching",
    options: [
      { id: "diaz-over-5-5", label: "Juno Diaz over 5.5 strikeouts", odds: 105, demoProbability: 0.51, market: "pitcher_strikeouts", team: "POR", player: "juno-diaz", direction: "over", line: 5.5 },
      { id: "diaz-under-5-5", label: "Juno Diaz under 5.5 strikeouts", odds: -125, demoProbability: 0.49, market: "pitcher_strikeouts", team: "POR", player: "juno-diaz", direction: "under", line: 5.5 },
    ],
  },
];

const basketballMarkets = [
  {
    id: "moneyline",
    label: "Game winner",
    options: [
      { id: "tor-win", label: "Toronto Towers to win", odds: -145, demoProbability: 0.61, market: "moneyline", team: "TOR", player: null, direction: null, line: null },
      { id: "mia-win", label: "Miami Waves to win", odds: 125, demoProbability: 0.39, market: "moneyline", team: "MIA", player: null, direction: null, line: null },
    ],
  },
  {
    id: "total-points",
    label: "Total points",
    options: [
      { id: "over-184-5", label: "Total over 184.5", odds: -105, demoProbability: 0.55, market: "total", team: null, player: null, direction: "over", line: 184.5 },
      { id: "under-184-5", label: "Total under 184.5", odds: -115, demoProbability: 0.45, market: "total", team: null, player: null, direction: "under", line: 184.5 },
    ],
  },
  {
    id: "spread",
    label: "Point spread",
    options: [
      { id: "tor-minus-4-5", label: "Toronto Towers -4.5", odds: -110, demoProbability: 0.53, market: "spread", team: "TOR", player: null, direction: null, line: -4.5 },
      { id: "mia-plus-4-5", label: "Miami Waves +4.5", odds: -110, demoProbability: 0.47, market: "spread", team: "MIA", player: null, direction: null, line: 4.5 },
    ],
  },
];

const hockeyMarkets = [
  {
    id: "moneyline",
    label: "Game winner",
    options: [
      { id: "mtl-win", label: "Montreal Voyageurs to win", odds: 105, demoProbability: 0.49, market: "moneyline", team: "MTL", player: null, direction: null, line: null },
      { id: "bos-win", label: "Boston Harbors to win", odds: -120, demoProbability: 0.51, market: "moneyline", team: "BOS", player: null, direction: null, line: null },
    ],
  },
  {
    id: "total-goals",
    label: "Total goals",
    options: [
      { id: "over-5-5", label: "Total over 5.5", odds: -125, demoProbability: 0.57, market: "total", team: null, player: null, direction: "over", line: 5.5 },
      { id: "under-5-5", label: "Total under 5.5", odds: 105, demoProbability: 0.43, market: "total", team: null, player: null, direction: "under", line: 5.5 },
    ],
  },
  {
    id: "puck-line",
    label: "Puck line",
    options: [
      { id: "mtl-plus-1-5", label: "Montreal Voyageurs +1.5", odds: -180, demoProbability: 0.7, market: "puck_line", team: "MTL", player: null, direction: null, line: 1.5 },
      { id: "bos-minus-1-5", label: "Boston Harbors -1.5", odds: 155, demoProbability: 0.3, market: "puck_line", team: "BOS", player: null, direction: null, line: -1.5 },
    ],
  },
];

const genericMarkets = (away, home, totalLabel) => [
  {
    id: "moneyline",
    label: "Game winner",
    options: [
      { id: "away-win", label: `${away} to win`, odds: 115, demoProbability: 0.45, market: "moneyline", team: away, player: null, direction: null, line: null },
      { id: "home-win", label: `${home} to win`, odds: -130, demoProbability: 0.55, market: "moneyline", team: home, player: null, direction: null, line: null },
    ],
  },
  {
    id: "total",
    label: totalLabel,
    options: [
      { id: "total-over", label: "Over", odds: -110, demoProbability: 0.52, market: "total", team: null, player: null, direction: "over", line: null },
      { id: "total-under", label: "Under", odds: -110, demoProbability: 0.48, market: "total", team: null, player: null, direction: "under", line: null },
    ],
  },
];

const attachGameContext = (game) => ({
  ...game,
  markets: game.markets.map((marketGroup) => ({
    ...marketGroup,
    options: marketGroup.options.map((option) => ({
      ...option,
      gameId: game.id,
      sport: game.sport,
    })),
  })),
});

export const GAMES = [
  {
    id: "sea-por",
    day: "today",
    phase: "live",
    sport: "baseball",
    league: "North League",
    away: { abbreviation: "SO", name: "Seattle Orcas", score: 3 },
    home: { abbreviation: "PP", name: "Portland Pioneers", score: 4 },
    state: "Bottom 6th",
    detail: "2 outs",
    defaultLegs: ["por-win", "over-7-5"],
    markets: baseballMarkets,
  },
  {
    id: "tor-mia",
    day: "today",
    phase: "live",
    sport: "basketball",
    league: "Atlantic Conference",
    away: { abbreviation: "TT", name: "Toronto Towers", score: 89 },
    home: { abbreviation: "MW", name: "Miami Waves", score: 84 },
    state: "Q4",
    detail: "5:42",
    defaultLegs: ["tor-win", "over-184-5"],
    markets: basketballMarkets,
  },
  {
    id: "mtl-bos",
    day: "today",
    phase: "live",
    sport: "hockey",
    league: "East Division",
    away: { abbreviation: "MV", name: "Montreal Voyageurs", score: 2 },
    home: { abbreviation: "BH", name: "Boston Harbors", score: 2 },
    state: "3rd",
    detail: "8:11",
    defaultLegs: ["bos-win", "over-5-5"],
    markets: hockeyMarkets,
  },
  {
    id: "la-sd",
    day: "today",
    phase: "upcoming",
    sport: "baseball",
    league: "West League",
    away: { abbreviation: "LA", name: "Los Angeles Aviators" },
    home: { abbreviation: "SS", name: "San Diego Surfers" },
    time: "7:05 PM",
    defaultLegs: ["away-win", "total-over"],
    markets: genericMarkets("Los Angeles Aviators", "San Diego Surfers", "Total runs"),
  },
  {
    id: "chi-ny",
    day: "today",
    phase: "upcoming",
    sport: "basketball",
    league: "Central Conference",
    away: { abbreviation: "CC", name: "Chicago Comets" },
    home: { abbreviation: "NK", name: "New York Knights" },
    time: "8:00 PM",
    defaultLegs: ["home-win", "total-over"],
    markets: genericMarkets("Chicago Comets", "New York Knights", "Total points"),
  },
  {
    id: "den-utah",
    day: "today",
    phase: "upcoming",
    sport: "hockey",
    league: "West Division",
    away: { abbreviation: "DP", name: "Denver Peaks" },
    home: { abbreviation: "US", name: "Utah Summit" },
    time: "9:30 PM",
    defaultLegs: ["away-win", "total-under"],
    markets: genericMarkets("Denver Peaks", "Utah Summit", "Total goals"),
  },
  {
    id: "atl-orl",
    day: "today",
    phase: "upcoming",
    sport: "soccer",
    league: "National Soccer",
    away: { abbreviation: "AA", name: "Atlanta Arrows" },
    home: { abbreviation: "OS", name: "Orlando Sol" },
    time: "7:30 PM",
    defaultLegs: ["home-win", "total-over"],
    markets: genericMarkets("Atlanta Arrows", "Orlando Sol", "Total goals"),
  },
  {
    id: "van-cal-final",
    day: "yesterday",
    phase: "final",
    sport: "hockey",
    league: "Pacific Division",
    away: { abbreviation: "VR", name: "Vancouver Rain", score: 3 },
    home: { abbreviation: "CF", name: "Calgary Frontier", score: 1 },
    state: "Final",
    detail: "",
    defaultLegs: ["away-win", "total-over"],
    markets: genericMarkets("Vancouver Rain", "Calgary Frontier", "Total goals"),
  },
  {
    id: "det-cle-final",
    day: "yesterday",
    phase: "final",
    sport: "baseball",
    league: "Central League",
    away: { abbreviation: "DM", name: "Detroit Motors", score: 5 },
    home: { abbreviation: "CL", name: "Cleveland Lakes", score: 2 },
    state: "Final",
    detail: "",
    defaultLegs: ["away-win", "total-over"],
    markets: genericMarkets("Detroit Motors", "Cleveland Lakes", "Total runs"),
  },
  {
    id: "phi-bal-tomorrow",
    day: "tomorrow",
    phase: "upcoming",
    sport: "baseball",
    league: "East League",
    away: { abbreviation: "PB", name: "Philadelphia Bells" },
    home: { abbreviation: "BB", name: "Baltimore Blues" },
    time: "1:10 PM",
    defaultLegs: ["away-win", "total-under"],
    markets: genericMarkets("Philadelphia Bells", "Baltimore Blues", "Total runs"),
  },
  {
    id: "dal-phx-tomorrow",
    day: "tomorrow",
    phase: "upcoming",
    sport: "basketball",
    league: "National Conference",
    away: { abbreviation: "DS", name: "Dallas Stars" },
    home: { abbreviation: "PF", name: "Phoenix Fire" },
    time: "8:30 PM",
    defaultLegs: ["home-win", "total-over"],
    markets: genericMarkets("Dallas Stars", "Phoenix Fire", "Total points"),
  },
].map(attachGameContext);

export function initialSelections() {
  return {
    "sea-por": ["por-win", "over-7-5"],
    "tor-mia": ["tor-win"],
  };
}
